export default __webpack_public_path__ + "static/media/empty-heart.fabef7cb.png";